import styled from 'styled-components'

export const TermsAndConditions = styled.div`
  height: 280px;
  border: 1px solid #dedede;
  padding: 15px;
  border-radius: 5px;
`
